import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Switch, Redirect, useLocation } from 'react-router-dom';
import findIndex from 'lodash/findIndex';
import cx from 'classnames';

import { ROUTES } from 'enum';
import UnauthorizedRoute from 'components/UnauthorizedRoute';
import Stepper from 'components/Stepper';
import { extractLastValueFromPathname } from 'utils/routeLocationParsers';
import EmailSubForm from './EmailSubForm';
import ContractIdForm from './ContractIdForm';
import PersonalInfoSubForm from './PersonalInfoSubForm';
import OrgInfoSubForm from './OrgInfoSubForm';
import EmailConfirmation from './EmailConfirmation';
import EmailEntered from '../EmailEntered';
import { removeAuthError } from './scenario-actions';

import './sign-up-form.scss';

const steps = [
  { title: 'USER PROFILE', endpoint: '/personal-info' },
  { title: 'ORGANIZATION PROFILE', endpoint: '/org-info' },
  { title: 'CONTRACT', endpoint: '/contract-id' },
];
const EMAIL_PATH = '/email';
const EMAIL_ENTERED_PATH = '/email-entered';

function SignUpForm() {
  const dispatch = useDispatch();
  const location = useLocation();
  const customers = useSelector((state) => state.auth.customers);

  useEffect(() => {
    dispatch(removeAuthError());
  }, [dispatch]);

  const endpoint = `/${extractLastValueFromPathname(location)}`;
  const stepIndex = findIndex(steps, (step) => step.endpoint === endpoint);
  const shouldStepsBeDisplayed = stepIndex >= 0;
  const isEmail = ['/', '/sign-up', EMAIL_PATH, EMAIL_ENTERED_PATH].includes(endpoint);
  const loginFormWrapperClasses = cx('sign-up-form', {
    'personalInfo-form': stepIndex === 0,
    'orgInfo-form': stepIndex === 1,
    'payment-form': stepIndex === 2,
  });
  const isStepper = shouldStepsBeDisplayed && (!customers || !customers.length);

  return (
    <>
      <Helmet>
        <title>Sign up on Sectrify</title>
      </Helmet>
      <div className="signup-form-page--content">
        {isStepper && <Stepper steps={steps} activeStepIndex={stepIndex} />}
        <div className={loginFormWrapperClasses}>
          {isEmail && <h2 className="signup-title">Sign up</h2>}
          <Switch>
            <UnauthorizedRoute exact path={ROUTES.PERSONAL_INFO} component={PersonalInfoSubForm} />
            <UnauthorizedRoute exact path={ROUTES.ORG_INFO} component={OrgInfoSubForm} />
            <UnauthorizedRoute exact path={ROUTES.CONTRACT} component={ContractIdForm} />
            <UnauthorizedRoute exact path={ROUTES.SIGN_UP_EMAIL_CONFIRMATION} component={EmailConfirmation} />
            <UnauthorizedRoute exact path={ROUTES.SIGN_UP_EMAIL_ENTERED} component={EmailEntered} />
            <UnauthorizedRoute exact path={ROUTES.SIGN_UP_EMAIL} component={EmailSubForm} />
            <UnauthorizedRoute exact path={`${ROUTES.SIGN_UP}/`} component={EmailSubForm} />
            <Redirect to={ROUTES.LOGIN} />
          </Switch>
        </div>
      </div>
    </>
  );
}

export default SignUpForm;
